/* eslint-disable */
//tslint:disable

export interface ISecurityItemSchema {
  /** Значение **/
  title: string;
  /** Тип безопасности **/
  type: EType;
}

export enum EType {
  /** Пропускная система **/
  Access = 'access',
  /** Круглосуточная охрана **/
  AroundTheClock = 'aroundTheClock',
  /** Видеонаблюдение **/
  Camera = 'camera',
  /** Консьерж **/
  Concierge = 'concierge',
  /** Противопожарная система **/
  Fire = 'fire',
  /** Охраняемая парковка **/
  Parking = 'parking',
  /** Огороженный периметр **/
  Perimetr = 'perimetr',
  /** Сигнализация **/
  Signal = 'signal',
}
